var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 103 75",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M57.582 74.033V43.01C57.582 12.673 72.476.493 99.33.033l2.933 14.479c-15.57 1.608-23.243 9.652-22.115 22.751H94.14v36.77H57.582Zm-57.319 0V43.01C.263 12.673 15.157.493 42.011.033l2.934 14.479C29.374 16.12 21.7 24.164 22.83 37.263h13.99v36.77H.264Z",
  fill: "currentColor"
})));
export default SvgQuote;